export default {"src":"/_next/static/media/camera-plus.ac234331.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};